import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgVmManager = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-vm-manager';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M4.47 4.47 3.24 5.7v12.6l1.23 1.23 1.23 1.23h12.6l1.23-1.23 1.23-1.23V5.7l-1.23-1.23-1.23-1.23H5.7zm14 1.06.77.769v.581H4.76v-.579l.77-.771.769-.77h11.4zm.77 7.52v4.651l-.77.769-.771.77H6.301l-.771-.77-.77-.769V8.4h14.48zM9.531 9.61c-.075.095-2.431 4.204-2.424 4.227.012.04 2.381 4.141 2.423 4.193.031.039.574.05 2.47.05s2.439-.011 2.47-.05c.082-.103 2.421-4.172 2.42-4.21 0-.022-.548-.985-1.217-2.14l-1.216-2.1-2.443-.01c-1.925-.008-2.452 0-2.483.04m4.843 2.831c.432.748.786 1.37.786 1.381 0 .012-.353.633-.784 1.38l-.784 1.358h-3.184l-.784-1.358a60 60 0 0 1-.784-1.38c0-.011.354-.633.786-1.381l.786-1.361h3.176zm-2.607.165c-.374.06-.694.304-.896.685-.132.248-.131.812.002 1.069.236.454.627.695 1.127.695s.891-.241 1.127-.695c.133-.257.134-.821.002-1.069a1.4 1.4 0 0 0-.502-.545c-.15-.087-.241-.114-.567-.163a1.5 1.5 0 0 0-.293.023m.332 1.001c.122.055.168.201.107.335-.082.18-.367.163-.427-.025-.051-.16.028-.294.209-.354a.6.6 0 0 1 .111.044"
    })
  }));
});
export default SvgVmManager;